export default __webpack_public_path__ + "static/media/icons-digital.0e6f3ffd.svg";